import { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { apiStringify } from 'src/logic/helpers/api-query-string.helper';
import { Icon } from 'src/ui/shared/components/icon/Icon';
import { useActiveEntity } from 'src/ui/shared/hooks/active-entity.hook';
import { useIsCareerHubVersion } from 'src/ui/shared/hooks/is-careerhub-version.hook';
import { useRootSelector } from 'src/ui/shared/hooks/root-selector.hook';
import { EventSubPageTitle } from '../breadcrumbs/EventSubPageTitle';

export const EventBookingListPageNav = (): React.ReactElement => {
    const v5_17 = useIsCareerHubVersion(5, 17);
    const basePath = useRootSelector(state => state.configuration.value.careerHubBasePath);
    const { id } = useActiveEntity(state => state.eventUnions);
    const url = useMemo(() => {
        return `${basePath}/services/employers/v1/eventbookings/csv${apiStringify({
            eventIds: [id],
        })}`;
    }, [basePath, id]);

    return (
        <div className="d-flex align-items-center">
            <EventSubPageTitle>Bookings</EventSubPageTitle>
            {v5_17 && id && (
                <Button href={url} className="ml-2">
                    <Icon icon="download">Download</Icon>
                </Button>
            )}
        </div>
    );
};
